import React from 'react';
import { useURLParams } from '../hooks/useURLParams';

const HelloPage: React.FC = () => {
  const { code } = useURLParams();
  
  return (
    <section className="hello-page">
      {/* Background with gradient using existing palette */}
      <div className="hello-background">
        <div className="hello-background-overlay"></div>
      </div>

      {/* Content */}
      <div className="hello-content">
        <h1 className="hello-title-script">
          Bienvenido
        </h1>
        <p className="hello-message">
            espera...
          </p>
        {/* {code && (
          <p className="hello-message">
            Código de invitación no válido
          </p>
        )} */}
      </div>
    </section>
  );
};

export default HelloPage;